var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DEFFD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9153 54.4379C31.7799 54.4384 30.6909 53.9871 29.8888 53.1835L20.7384 44.0366C19.7539 43.0517 19.7539 41.4552 20.7384 40.4703C21.7233 39.4857 23.3198 39.4857 24.3047 40.4703L32.9153 49.0809L55.6953 26.3009C56.6802 25.3164 58.2767 25.3164 59.2616 26.3009C60.2461 27.2858 60.2461 28.8823 59.2616 29.8672L35.9419 53.1835C35.1397 53.9871 34.0508 54.4384 32.9153 54.4379Z",
    fill: "#08CB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f4c7d20a1532fcbb51c3a39c4bb0ff7c.svg";
export { ForwardRef as ReactComponent };